<template>
  <div id="appHolder" class="app">
    <ModalView />
    <router-view />
  </div>
</template>

<script>
import { useIdentityStore } from '@/store/IdentityStore';
import ModalView from '@/modal/ModalView.vue';
// import NelsonDebug from '@/components/nelson/NelsonDebug';

export default {
  name: 'App',
  created () {
    useIdentityStore().init();
  },
  components: {
    //  NelsonDebug,
    ModalView
  }
};
</script>

<style>
body {
  margin: 0 !important;
}
</style>